export default "__VITE_ASSET__a285079a__"